import { Component, Input, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Observable } from 'rxjs/Observable';
import { ReservationStore } from '../../service/reservation-store';
import { DateRoomType } from '../../models/date-room-type';
import { DateRoomTypeNight } from '../../models/date-room-type-night';
import { List } from 'immutable';
import { RoomTypeNights } from '../../models/room-type-nights';
import { OverviewStore } from '../../service/overview.store';
import { TranslateService } from '@ngx-translate/core';
import { Party } from 'app/event/models/party';

@Component({
  selector: 'pioneer-date-room-type-summary',
  templateUrl: './date-room-type-summary.component.html'
})
export class DateRoomTypeSummaryComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public dateRoomTypeDetail$: Observable<List<DateRoomTypeNight>>;
  public dateRoomTypeTotal$: Observable<List<RoomTypeNights>>;
  totalRoomNights$: Observable<number>;

  @Input() vendor: Party;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  constructor(private overviewStore: OverviewStore,
              private translateService: TranslateService) {
  }

  ngOnInit() {

    this.dateRoomTypeDetail$ = this.overviewStore.vendorDateStaySummary(this.vendor.eventPartyId).map((dateRoomType: DateRoomType) => {
      if (dateRoomType && dateRoomType.dateRoomTypeNightDetail) {
        return dateRoomType.dateRoomTypeNightDetail.dateRoomTypeNights;
      } else {
        return null;
      }

    });

    this.dateRoomTypeTotal$ = this.overviewStore.vendorDateStaySummary(this.vendor.eventPartyId).map((dateRoomType: DateRoomType) => {
      if (dateRoomType && dateRoomType.dateRoomTypeNightTotal) {
        return dateRoomType.dateRoomTypeNightTotal.nightsByRoomType;
      } else {
        return null;
      }

    });

    this.totalRoomNights$ = this.calculateTotalRoomNights();

  }

  public translateUnknownRoomType(roomType: string): string {

    if ('UNKNOWN_ROOM_TYPE' === roomType) {
      return this.translateService.instant('EVENT.OVERVIEW_CARDS.UNKNOWN_ROOM_TYPE');
    } else {
      return roomType;
    }
  }

  calculateTotalRoomNights(): Observable<number> {
    // Calculate the total room nights for the event party
    return this.dateRoomTypeTotal$.map(arrayInput => {
      return arrayInput.reduce((accum, current) => accum + current.nights, 0);
    });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/overview/date-room-type-summary/date-room-type-summary.component.ts